export const RENDER_MAIN_UI = 'buildYourOdds.ui.renderMainUi';
export const UI_READY = 'buildYourOdds.ui.ready';
export const OPEN_BUILD_YOUR_ODDS_EVENT = 'wh.sports.buildYourOdds.open.event';
export const OPEN_BUILD_YOUR_ODDS_MODAL = 'openBuildYourOddsModal';
export const CLOSE_BUILD_YOUR_ODDS_MODAL = 'closeBuildYourOddsModal';
export const BET_BUILDER_MODAL_IS_OPEN = 'wh.sports.betBuilderModal.is.open';
export const GET_ODDS_FORMAT = 'onOddsFormatChanged';
export const EDIT_BUILD_YOUR_ODDS_SELECTION = 'wh.sports.buildYourOdds.edit.selection';
export const MONITORING_PREFIX = 'BYO_MODAL';
export const MONITORING_OPEN_MODAL = `${MONITORING_PREFIX}/OPEN`;
export const MONITORING_CLOSE_MODAL = `${MONITORING_PREFIX}/CLOSE`;
export const MONITORING_ADD_TO_BETSLIP = `${MONITORING_PREFIX}/ADD_TO_SLIP`;
export const SESSION_STATE_NOT_LOGGED_IN = 'NOT_LOGGED_IN';
export const SESSION_STATE_LOGGED_IN = 'LOGGED_IN';
export const BYO_MARKET_NO_ROWS = 1000;
export const START_NEW_LOGIN_PROCESS = 'wh.common.command.ui.login.flow.start';
export const BYO_CAMPAIGN_QUERY_PARAM = 'byo';
export const EN_GB_LOCALE = 'en-gb';
export const ES_ES_LOCALE = 'es-es';
export const EN_LOCALE = 'en';
export const EE_LOCALE = 'ee';
export const PUSH_SUBSCRIBE_OWNER = 'byo-modal';
export const ERRORS = {
    BYO_GENERIC_ERROR: 'BYO_GENERIC_ERROR',
    BYO_GET_BYO_PRICE_ERROR: 'BYO_GET_BYO_PRICE_ERROR'
};
export const BYO_NGS_RESOURCE_NAME = 'sb-build-yourodds';
export const BYO_FAVOURITES_STORAGE_KEY = 'WH::SB:BYO:favourites';
export const MB_ANALYTICS_ADAPTER_READY = 'wh.analytics.adapter.ready';
export const MB_ANALYTICS_PARTIAL_EVENT = 'wh.common.command.dli.tl.eventPartial';
export const MB_ANALYTICS_FEATURE_FLAG_TRACK_EVENT = 'wh.analytics.featureFlag.trackEvent';
export const BYO_TO_BET_BUILDER_FEATURE_FLAG = 'byo_to_bet_builder';
export const OPTIMIZELY_ADD_FAVOURITE_EVENT_KEY = 'add_favourite_byo_market';
export const GET_FEATURE_FLAG = 'sb.featureFlag.getFeatureFlag';
export const NATIVE_CLOSE_DRAWER = 'betslip.closeDrawers';
export const BROADCAST_REGION_ID_UK = '35';
export const BROADCAST_REGION_ID_ES = '45';
export const NOT_APPLICABLE_PRICE = 'N/A';
export const DEFAULT_MARKET_CATEGORY = 'ALL';
export const IMPACT_SUB_MARKET_CATEGORY = 'IMPACTSUB';
export const NOT_AVAILABLE = 'N/A';
export const BYO_FAVOURITES_ICON = '★';
// Header configuration
export const HEADER_ID = 'byo-modal-header';
export const MAX_IMAGE_HEIGHT = 193;
export const MIN_IMAGE_HEIGHT = 111;
export const HEIGHT_RATIO_THRESHOLD = 0.82;
export const SCROLL_DEBOUNCE_TIME = 10;
export const CATEGORIES = {
    // football
    RESULT: 'RESULT',
    BOTH_TEAMS_TO_SCORE: 'BOTH_TEAMS_TO_SCORE',
    TOTAL_GOALS: 'TOTAL_GOALS',
    TOTAL_GOAL_KICKS: 'TOTAL_GOAL_KICKS',
    TOTAL_CARDS: 'TOTAL_CARDS',
    TOTAL_CORNERS: 'TOTAL_CORNERS',
    CORRECT_SCORE: 'CORRECT_SCORE',
    DOUBLE_CHANCE: 'DOUBLE_CHANCE',
    TEAM_WITH_MOST_CORNERS: 'TEAM_WITH_MOST_CORNERS',
    PLAYER_FOULS: 'PLAYER_FOULS',
    PLAYER_OFFSIDES: 'PLAYER_OFFSIDES',
    PLAYER_TO_SCORE: 'PLAYER_TO_SCORE',
    PLAYER_TO_SCORE_OUTSIDE_BOX: 'PLAYER_TO_SCORE_OUTSIDE_BOX',
    PLAYER_TO_SCORE_A_HEADER: 'PLAYER_TO_SCORE_A_HEADER',
    PLAYER_TO_SCORE_LEFT_FOOT: 'PLAYER_TO_SCORE_LEFT_FOOT',
    PLAYER_TO_SCORE_RIGHT_FOOT: 'PLAYER_TO_SCORE_RIGHT_FOOT',
    PLAYER_TO_SCORE_A_FREE_KICK: 'PLAYER_TO_SCORE_A_FREE_KICK',
    PLAYER_TO_SCORE_INSIDE_6_YARD_BOX: 'PLAYER_TO_SCORE_INSIDE_6_YARD_BOX',
    PLAYER_TO_SCORE_OR_ASSIST: 'PLAYER_TO_SCORE_OR_ASSIST',
    TEAM_WITH_MOST_CARDS: 'TEAM_WITH_MOST_CARDS',
    DOUBLE_RESULT: 'DOUBLE_RESULT',
    PLAYER_TO_BE_CARDED: 'PLAYER_TO_BE_CARDED',
    FIRST_TEAM_TO_SCORE: 'FIRST_TEAM_TO_SCORE',
    COME_FROM_BEHIND: 'COME_FROM_BEHIND',
    TOTAL_BOOKING_POINTS: 'TOTAL_BOOKING_POINTS',
    TEAM_WITH_MOST_BOOKING_POINTS: 'TEAM_WITH_MOST_BOOKING_POINTS',
    MATCH_HANDICAP: 'MATCH_HANDICAP',
    TOTAL_FREE_KICKS: 'TOTAL_FREE_KICKS',
    TOTAL_THROW_INS: 'TOTAL_THROW_INS',
    HIGHEST_SCORING_HALF: 'HIGHEST_SCORING_HALF',
    RED_CARD: 'RED_CARD',
    QUALIFY_LIFT_THE_TROPHY: 'QUALIFY_LIFT_THE_TROPHY',
    PLAYER_TO_ASSIST: 'PLAYER_TO_ASSIST',
    PLAYER_SHOTS: 'PLAYER_SHOTS',
    PLAYER_SHOTS_ON_TARGET: 'PLAYER_SHOTS_ON_TARGET',
    METHOD_OF_GOAL: 'METHOD_OF_GOAL',
    PLAYER_TOTAL_SHOTS: 'PLAYER_TOTAL_SHOTS',
    PLAYER_TACKLES: 'PLAYER_TACKLES',
    PLAYER_TOTAL_TACKLES: 'PLAYER_TOTAL_TACKLES',
    MATCH_TO_GO_TO_PENALTIES: 'MATCH_TO_GO_TO_PENALTIES',
    TO_WIN_ON_PENALTIES: 'TO_WIN_ON_PENALTIES',
    TOTAL_TACKLES: 'TOTAL_TACKLES',
    TOTAL_SHOTS: 'TOTAL_SHOTS',
    TO_WIN_IN_EXTRA_TIME: 'TO_WIN_IN_EXTRA_TIME',
    TOTAL_SHOTS_ON_TARGET: 'TOTAL_SHOTS_ON_TARGET',
    METHOD_OF_GOAL_HOW: 'METHOD_OF_GOAL_HOW',
    METHOD_OF_GOAL_WHERE: 'METHOD_OF_GOAL_WHERE',
    QUALIFY: 'QUALIFY',
    CORNER_HANDICAP: 'CORNER_HANDICAP',
    CARD_HANDICAP: 'CARD_HANDICAP',
    WINNING_MARGIN: 'WINNING_MARGIN',
    PENALTY: 'PENALTY',
    // basketball and american football
    POINTS_HANDICAP: 'POINTS_HANDICAP',
    MONEY_LINE: 'MONEY_LINE',
    TOTAL_POINTS: 'TOTAL_POINTS',
    // basketball
    BLOCKS: 'BLOCKS',
    STEALS: 'STEALS',
    TURNOVERS: 'TURNOVERS',
    BLOCKS_STEALS: 'BLOCKS_STEALS',
    THREE_MADE: 'THREE_MADE',
    ASSISTS: 'ASSISTS',
    REBOUNDS: 'REBOUNDS',
    ASSISTS_REBOUNDS: 'ASSISTS_REBOUNDS',
    POINTS: 'POINTS',
    POINTS_ASSISTS: 'POINTS_ASSISTS',
    POINTS_REBOUNDS: 'POINTS_REBOUNDS',
    POINTS_ASSISTS_REBOUNDS: 'POINTS_ASSISTS_REBOUNDS',
    DOUBLE_DOUBLE: 'DOUBLE_DOUBLE',
    TRIPLE_DOUBLE: 'TRIPLE_DOUBLE',
    // american football
    PLAYER_TO_SCORE_TOUCHDOWN: 'PLAYER_TO_SCORE_TOUCHDOWN',
    EXTRA_POINT_MADE: 'EXTRA_POINT_MADE',
    FIELD_GOAL_MADE: 'FIELD_GOAL_MADE',
    INTERCEPTIONS: 'INTERCEPTIONS',
    KICKING_POINTS: 'KICKING_POINTS',
    LONGEST_PASSING_COMPLETION: 'LONGEST_PASSING_COMPLETION',
    LONGEST_RECEPTION: 'LONGEST_RECEPTION',
    PASSING_ATTEMPTS: 'PASSING_ATTEMPTS',
    PASSING_COMPLETIONS: 'PASSING_COMPLETIONS',
    PASSING_TOUCHDOWNS: 'PASSING_TOUCHDOWNS',
    PASSING_YARDS: 'PASSING_YARDS',
    RECEIVING_YARDS: 'RECEIVING_YARDS',
    RECEPTIONS: 'RECEPTIONS',
    RUSHING_ATTEMPTS: 'RUSHING_ATTEMPTS',
    RUSHING_YARDS: 'RUSHING_YARDS',
    TACKLES_ASSISTS: 'TACKLES_ASSISTS',
    MATCH_2PT_MADE: 'MATCH_2PT_MADE',
    MATCH_LOST_FUMBLES: 'MATCH_LOST_FUMBLES',
    MATCH_OFFENSE_YARDS: 'MATCH_OFFENSE_YARDS',
    MATCH_PASSING_YARDS: 'MATCH_PASSING_YARDS',
    MATCH_RUSHING_YARDS: 'MATCH_RUSHING_YARDS',
    MATCH_SACKS: 'MATCH_SACKS',
    MATCH_TACKLES_ASSISTS: 'MATCH_TACKLES_ASSISTS',
    TEAM_2PT_MADE: 'TEAM_2PT_MADE',
    TEAM_DEFENSIVE_TACKLES_AND_ASSISTS: 'TEAM_DEFENSIVE_TACKLES_AND_ASSISTS',
    TEAM_LOST_FUMBLES: 'TEAM_LOST_FUMBLES',
    TEAM_OFFENSE_YARDS: 'TEAM_OFFENSE_YARDS',
    TEAM_PASSING_YARDS: 'TEAM_PASSING_YARDS',
    TEAM_RUSHING_YARDS: 'TEAM_RUSHING_YARDS',
    TEAM_SACKS: 'TEAM_SACKS',
    //nba
    TEAM_ASSISTS: 'TEAM_ASSISTS',
    TEAM_THREES_MADE: 'TEAM_THREES_MADE',
    TEAM_TURNOVERS: 'TEAM_TURNOVERS',
    TEAM_REBOUNDS: 'TEAM_REBOUNDS',
    TEAM_STEALS: 'TEAM_STEALS',
    TEAM_BLOCKS: 'TEAM_BLOCKS',
    WIN_ON_PENALTIES: 'WIN_ON_PENALTIES',
    WIN_IN_EXTRA_TIME: 'WIN_IN_EXTRA_TIME',
    PLAYER_TO_BE_SENT_OFF: 'PLAYER_TO_BE_SENT_OFF',
};
// Players positions
export const PLAYERS_POSITIONS = {
    GOALKEEPER: 'Goalkeeper',
    WING_BACK: 'Wing Back',
    DEFENDER: 'Defender',
    DEFENSIVE_MIDFIELDER: 'Defensive Midfielder',
    MIDFIELDER: 'Midfielder',
    ATTACKING_MIDFIELDER: 'Attacking Midfielder',
    ATTACKER: 'Attacker',
    STRIKER: 'Striker',
    UNKNOWN: 'Unknown'
};
// LINEUPS_FORMATION_CONFIG contains grid representation of pitch view for each existing formation
// key: string - formationUsed from starting lineup data - team attribute
// value: number[][] - grid representation of pitch view
// each list from value: number[] - represents each row for pitch view starting from the top where exists only goalkeeper ([1])
// each number in row list: number - represents formationPlace which is player's attribute
export const LINEUPS_FORMATION_CONFIG = {
    '442': [[1], [2, 5, 6, 3], [7, 4, 8, 11], [10, 9]],
    '41212': [[1], [2, 5, 6, 3], [4], [7, 11], [8], [10, 9]],
    '433': [[1], [2, 5, 6, 3], [7, 4, 8], [10, 9, 11]],
    '451': [[1], [2, 5, 6, 3], [7, 4, 10, 8, 11], [9]],
    '4411': [[1], [2, 5, 6, 3], [7, 4, 8, 11], [10], [9]],
    '4141': [[1], [2, 5, 6, 3], [4], [7, 8, 10, 11], [9]],
    '4231': [[1], [2, 5, 6, 3], [8, 4], [7, 10, 11], [9]],
    '4321': [[1], [2, 5, 6, 3], [8, 4, 7], [10, 11], [9]],
    '532': [[1], [2, 6, 5, 4, 3], [7, 8, 11], [10, 9]],
    '541': [[1], [2, 6, 5, 4, 3], [7, 8, 10, 11], [9]],
    '352': [[1], [6, 5, 4], [2, 7, 11, 8, 3], [10, 9]],
    '343': [[1], [6, 5, 4], [2, 7, 8, 3], [10, 9, 11]],
    '4222': [[1], [2, 5, 6, 3], [4, 8], [7, 11], [10, 9]],
    '3511': [[1], [6, 5, 4], [2, 7, 11, 8, 3], [10], [9]],
    '3421': [[1], [6, 5, 4], [2, 7, 8, 3], [10, 11], [9]],
    '3412': [[1], [6, 5, 4], [2, 7, 8, 3], [9], [10, 11]],
    '3142': [[1], [5, 4, 6], [8], [2, 7, 11, 3], [9, 10]],
    '343d': [[1], [6, 5, 4], [8], [2, 3], [7], [10, 9, 11]],
    '4132': [[1], [2, 5, 6, 3], [4], [7, 8, 11], [9, 10]],
    '4240': [[1], [2, 5, 6, 3], [4, 8], [7, 9, 10, 11]],
    '4312': [[1], [2, 5, 6, 3], [7, 4, 11], [8], [9, 10]],
    '3241': [[1], [6, 5, 4], [2, 3], [10, 7, 8, 11], [9]],
    '3331': [[1], [6, 5, 4], [2, 8, 3], [10, 7, 11], [9]],
};
export const SUPPORTED_BOOST_LOCALE = [
    EN_GB_LOCALE, ES_ES_LOCALE
];
